import { Injectable } from '@angular/core';
import { StoreService } from './store.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(
    private storeService: StoreService,
    private router: Router,
  ) {}

  isAuthorized(url: String) {
    console.log(url);
    let isAuthorized: boolean = true;
    switch (url) {
      case '/producers-wastes':
        isAuthorized = this.canDisplayProducersWastes();
        break;
      case '/suppliers':
        isAuthorized = this.canDisplaySuppliers();
        break;
      case '/price-list':
        isAuthorized = this.canDisplayPriceList();
        break;
      case '/transport-mass-price':
         isAuthorized = this.canDisplayTransportMassPrice()
         break;
      case '/demand-prestations':
        isAuthorized = this.canDisplayDemandPrestations();
        break;
      case '/prestations-completed':
        isAuthorized = this.canDisplayPrestationsCompleted();
        break;
      case '/integrate-services':
        isAuthorized = this.canDisplayIntegratePrestationEffectuees();
        break;
      case '/purchase-orders':
        isAuthorized = this.canDisplayPurchaseOrders();
        break;
      case '/billing-preparation':
        isAuthorized = this.canDisplayBillingPreparation();
        break;
      case '/customer-control':
        isAuthorized = this.canDisplayCustomerControl();
        break;
      case '/technical-reports':
        isAuthorized = this.canDisplayTechnicalReports();
        break;
      case '/reporting':
        isAuthorized = this.canDisplayReporting();
        break;
      case '/contracts':
        isAuthorized = this.canDisplayContracts();
        break;
      case '/users':
        isAuthorized = this.canDisplayUsers();
        break;
      case '/tgap':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/referentials':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/configuration':
        isAuthorized = this.canDisplayConfiguration();
        break;
      case '/referentials/natures':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/referentials/conditionnements':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/referentials/prestations':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/referentials/immobilisation-demande':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/referentials/annulation-demande':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/referentials/adr':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/referentials/ced':
        isAuthorized = this.canDisplayReferentials();
        break;
      case '/referentials/units':
        isAuthorized = this.canDisplayReferentials();
        break;
      default:
        isAuthorized = true;
    }
    return isAuthorized;
  }

  // --- Grid --- //

  canDisplayGrid(): boolean {
    return this.canDisplayProducersWastes() || this.canDisplaySuppliers() || this.canDisplayPriceList();
  }

  canDisplayProducersWastes(): boolean {
    return this.storeService.hasAtLeastAuthority('GRILLE_PRODUCTEUR_DECHET_RO', 'GRILLE_PRODUCTEUR_DECHET_RW');
  }

  canDisplaySuppliers(): boolean {
    return this.storeService.hasAtLeastAuthority('GRILLE_FOURNISSEUR_RO', 'GRILLE_FOURNISSEUR_RW');
  }

  canDisplayPriceList(): boolean {
    return this.storeService.hasAtLeastAuthority('GRILLE_TARIFS_RO', 'GRILLE_TARIFS_RW', 'GRILLE_TARIFS_SS_PRIX_RO', 'GRILLE_TARIFS_CLIENT_RO');
  }

  canDisplayTransportMassPrice(): boolean {
    return this.storeService.hasAtLeastAuthority('GRILLE_TARIFS_RO', 'GRILLE_TARIFS_RW', 'GRILLE_TARIFS_SS_PRIX_RO', 'GRILLE_TARIFS_CLIENT_RO');
  }

  // --- Requests --- //

  canDisplayDemands(): boolean {
    return this.canDisplayDemandPrestations();
  }

  canDisplayDemandPrestations(): boolean {
    return this.storeService.hasAtLeastAuthority('DEMANDE_DEMANDE_RO', 'DEMANDE_DEMANDE_RW'); // FIXME
  }

  // --- Services --- //

  canDisplayServices(): boolean {
    return this.canDisplayPrestationsCompleted() || this.canDisplayPurchaseOrders();
  }

  canDisplayPrestationsCompleted(): boolean {
    return this.storeService.hasAtLeastAuthority('PRESTATION_PRESTATION_EFFECTUEE_RO', 'PRESTATION_PRESTATION_EFFECTUEE_RW');
  }

  canDisplayPurchaseOrders(): boolean {
    return this.storeService.hasAtLeastAuthority('PRESTATION_FACTURE_FOUR_RO', 'PRESTATION_FACTURE_FOUR_RW'); // FIXME
  }

  canDisplayIntegratePrestationEffectuees(): boolean {
    return this.storeService.hasAtLeastAuthority('PRESTATION_INTEGRATION_PRESTATION_EFFECTUEE'); // FIXME
  }

  // --- Billing --- //

  canDisplayBilling(): boolean {
    return this.canDisplayBillingPreparation() || this.canDisplayCustomerControl() || this.canDisplayTechnicalReports() || this.canDisplayReporting();
  }
  canDisplayBillingPreparation(): boolean {
    return this.storeService.hasAtLeastAuthority('FACTURATION_PREPARER_RO', 'FACTURATION_PREPARER_RW');
  }
  canDisplayCustomerControl(): boolean {
    return this.storeService.hasAtLeastAuthority('FACTURATION_CONTROLER_RO', 'FACTURATION_CONTROLER_RW');
  }
  canDisplayTechnicalReports(): boolean {
    return this.storeService.hasAtLeastAuthority('FACTURATION_RT_RO', 'FACTURATION_RT_RW', 'FACTURATION_RT_RO_SS_RT_FOURNISSEUR');
  }
  canDisplayReporting(): boolean {
    return this.storeService.hasAtLeastAuthority('FACTURATION_REPORTING_PRIX', 'FACTURATION_REPORTING_PRIX_COUT'); // FIXME
  }

  // --- Parameters --- //

  canDisplayParameters(): boolean {
    return this.canDisplayContracts() || this.canDisplayUsers() || this.canDisplayReferentials() || this.canDisplayMonitoring() || this.canDisplayConfiguration();
  }
  canDisplayContracts(): boolean {
    return this.storeService.hasAtLeastAuthority('PARAMETRES_CONTRAT');
  }
  canDisplayUsers(): boolean {
    return this.storeService.hasAtLeastAuthority('PARAMETRES_UTILISATEUR_RO', 'PARAMETRES_UTILISATEUR_RW');
  }

  canDisplayReferentials(): boolean {
    return this.storeService.hasAtLeastAuthority('PARAMETRES_REFERENTIEL_RO', 'PARAMETRES_REFERENTIEL_RW');
  }
  canDisplayMonitoring(): boolean {
    return this.storeService.hasAtLeastAuthority('PARAMETRES_MONITORING');
  }
  canDisplayConfiguration(): boolean {
    return this.storeService.hasAtLeastAuthority('PARAMETRES_CONFIGURATION');
  }
}
